var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "width50 marketingHubPage__results--products cursor-pointer",
    },
    [
      _c(
        "a",
        {
          staticClass:
            "marketingLinks results--product focus-inset flex flex-center",
          attrs: { href: _vm.matchMarketLink, "data-gtm": _vm.gtm },
        },
        [
          _c("div", { staticClass: "margin-left-20" }, [
            _c(
              "svg",
              {
                class: _vm.iconClass,
                attrs: {
                  viewBox: "0 0 32 32",
                  width: "32",
                  height: "32",
                  xmlns: "http://www.w3.org/2000/svg",
                  "aria-hidden": "true",
                },
              },
              [
                _c("circle", {
                  staticClass: "outlookClusterIcon__backgroundCircle",
                  attrs: { cx: "16", cy: "16", r: "16" },
                }),
                _vm._v(" "),
                _c("path", {
                  staticClass: "outlookClusterIcon__iconPath",
                  attrs: {
                    d: _vm.svgIcon,
                    fill: "none",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "flex flex--nowrap padding-right-20" }, [
            _c("div", [
              _c(
                "h2",
                {
                  staticClass:
                    "marketingHubPage__results--market margin-bottom-5 text-color--dark-blue-gray",
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.match.market) +
                      "\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "small",
                {
                  staticClass:
                    "resultsItem--product__small marketingHubPage__resultsHeader--topic",
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.marketName) +
                      "\n                "
                  ),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }